module.exports = __webpack_public_path__ + "static/media/refer.382c6f36.svg";